export default "__VITE_ASSET__b$yRmE_L__"